import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-custom-true-false',
  templateUrl: './custom-true-false.component.html',
  styleUrls: ['./custom-true-false.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomTrueFalseComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CustomTrueFalseComponent,
    },
  ],
})
export class CustomTrueFalseComponent {
  @Input()
  title = "Select Option...";

  @Input()
  isDisabled = false;

  public value?: boolean;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: boolean | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: boolean) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.unformatObject(this.value);
    }
  }

  onValueChange(val: string) {
    this.value = val.toLowerCase() == 'yes';
    this.onChange(this.value);
  }

  formatObject(val: string) {
    return val.toLowerCase() == 'yes';
  }

  unformatObject(val: boolean) {
    return val ? 'Yes' : 'No';
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
